import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, InputSignal, Output, Signal } from '@angular/core';
import { DATA_DISPLAY_TYPES } from './data-display-type';
import { StatusChipComponent } from '@shared/components/status-chip/status-chip.component';
import { DatePipe } from '@angular/common';
import { LanguageSelectionService } from '@shared/components/language-selection/services/language-selection/language-selection.service';
import { LocaleConfig, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { toSignal } from '@angular/core/rxjs-interop';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import { TableData } from './types/table-data.type';
import { MatButtonModule } from '@angular/material/button';
import { TableDataActionClick } from './types/table-data-action-click.type';
import { DurationPipe } from '@shared/pipes/duration.pipe';
import { DatePeriodPipe } from '@shared/pipes/date-period.pipe';
import { TimePeriodPipe } from '@shared/pipes/time-period.pipe';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-bcl-table-data',
  standalone: true,
  imports: [ StatusChipComponent, DatePipe, IconModule, MatButtonModule, DurationPipe, TranslationPipeModule, DatePeriodPipe, TimePeriodPipe ],
  templateUrl: './bcl-table-data.component.html',
  styleUrl: './bcl-table-data.component.scss'
})
export class BclTableDataComponent {
  private readonly _languageSelectionService: LanguageSelectionService = inject(LanguageSelectionService);

  private readonly _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  protected currentLocale: Signal<LocaleConfig | undefined> = toSignal(this._languageSelectionService.currentLocale$);

  @Output() public readonly actionClick: EventEmitter<TableDataActionClick> = new EventEmitter<TableDataActionClick>();

  public tableData: InputSignal<TableData> = input.required<TableData>();

  protected readonly DATA_DISPLAY_TYPES: typeof DATA_DISPLAY_TYPES = DATA_DISPLAY_TYPES;

  constructor () {
    this._faIconLibrary.addIcons(faEdit);
  }

  protected onActionClick (): void {
    this.actionClick.emit({ actionId: this.tableData().type });
  }
}
